import { render, staticRenderFns } from "./RelatedProductBlock.vue?vue&type=template&id=25bd7e08&scoped=true&"
import script from "./RelatedProductBlock.vue?vue&type=script&lang=js&"
export * from "./RelatedProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductBlock.vue?vue&type=style&index=0&id=25bd7e08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd7e08",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
